var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Layout as AntLayout } from 'antd';
import { HeaderUser } from './Header/User';
import { HeaderTheme } from './Header/Theme';
import { HeaderNotifications } from './Header/Notifications';
import { HeaderComments } from './Header/Comments';
import { FooterCopyright } from './Footer/Copyright';
import { RadarLink } from './Footer/RadarLink';
import { HeaderFilter } from './Header/Filter';
export const Layout = styled(AntLayout) `
  background-color: var(--color-bg-main);
`;
Layout.Header = styled(AntLayout.Header) `
  background-color: var(--color-base-dark1);
  color: var(--color-base-white);
  height: 45px;
  line-height: 45px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--color-base-gray4);

  & > div:last-child {
    display: flex;
  }

  /* Menu in header */
  .ant-menu.ant-menu-horizontal {
    border-bottom: 0;
  }

  .ant-menu.ant-menu-horizontal .ant-menu-item {
    border-bottom: 0;
    margin-right: 24px;
    margin-left: 24px;
    font-size: 14px;
    padding: 0;
  }

  /* There are 2 types of styles: when menu contains <a> links and text only. We need to make them same */
  .ant-menu.ant-menu-horizontal > .ant-menu-item-selected,
  .ant-menu.ant-menu-horizontal .ant-menu-item:hover,
  .ant-menu.ant-menu-horizontal > .ant-menu-item-selected a,
  .ant-menu.ant-menu-horizontal .ant-menu-item:hover a {
    border-bottom: 0;
  }

  .ant-menu-horizontal > li.ant-menu-item,
  .ant-menu-horizontal > li.ant-menu-item a,
  a {
    color: var(--color-base-gray6);
  }

  .ant-menu-horizontal > li.ant-menu-item:hover,
  .ant-menu-horizontal > li.ant-menu-item:hover a,
  a:hover {
    color: var(--color-base-gray2);
  }

  .ant-menu-horizontal > li.ant-menu-item-selected {
    a,
    span {
      color: var(--color-base-white);
    }
  }
`;
Layout.SubHeader = styled(Layout.Header) `
  background-color: var(--color-bg-subheader);
  border-bottom: 1px solid var(--color-border-subheader);

  .ant-menu {
    margin: 0 auto;
  }

  .ant-badge .ant-badge-count {
    background-color: var(--color-base-gray3);
    right: -8px;
  }

  /* Text */
  .ant-menu-horizontal > li.ant-menu-item:hover,
  .ant-menu-horizontal > li.ant-menu-item:hover a,
  a:hover {
    color: var(--color-text-subheader-hover);
  }

  .ant-menu-horizontal > li.ant-menu-item-selected {
    a,
    span {
      color: var(--color-text-subheader-selected);
    }
  }
`;
Layout.Footer = styled(AntLayout.Footer) `
  background-color: transparent;
  color: var(--color-text-footer);
  padding: 5px 16px 5px;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid var(--color-border-subheader);

  a {
    color: var(--color-text-footer);
  }

  a:hover {
    color: var(--color-text-menu-hover);
  }

  a + a {
    margin-left: 24px;
  }
`;
Layout.Content = styled(AntLayout.Content) `
  padding: 32px;
`;
const StyledSider = styled(AntLayout.Sider) `
  background-color: transparent;

  .ant-layout-sider-children > .ant-menu {
    margin-top: 32px;
  }
`;
Layout.Header.User = HeaderUser;
Layout.Header.ThemeSwitcher = HeaderTheme;
Layout.Header.Notifications = HeaderNotifications;
Layout.Header.Comments = HeaderComments;
Layout.Header.Filter = HeaderFilter;
Layout.Footer.Copyright = FooterCopyright;
Layout.Footer.RadarLink = RadarLink;
Layout.Sider = function Sider(_a) {
    var { width = 230 } = _a, props = __rest(_a, ["width"]);
    return React.createElement(StyledSider, Object.assign({ width: width }, props));
};
